import React, { useEffect, useRef, useState } from "react";
import { ConsultaPedidoRelatorioRomaneio } from "../funcionalidades/bancoGet";
import GlobalVar from "../subComponents/GlobalVar";
import TopMenu from '../TopMenu'
import { useSearchParams } from "react-router-dom";
import JsBarcode from "jsbarcode";


const ItemCard = ({notaInfo, subItem}) =>{
    const urlImage = `https://apirevendedoratime.babita.com.br/images/${subItem.sku}.jpg`

    const [bg, setBg] = useState('#FFF');
    
      useEffect(() => {
          //console.log("TESTE IMAGE")
        const img = new Image();
        img.src = urlImage;
    
        img.onload = () => {
          setBg(`url('${urlImage}')`);
        };
    
        img.onerror = () => {
          setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
        };
      }, [urlImage]);


      return <> 
                                <div className="subItemMov fornecedor" key={`subItens${notaInfo.cabecalho.documento_origem}`}>
                                    <div className='fotoProd'
                                style={{background: `${bg} no-repeat center/contain`}}></div>
                                    <div className="descricoes">
                                        <div>{subItem.fabricante.substr(0,24)}</div>
                                        <div>{subItem.item.substr(0,38)}</div>
                                        <div>PAG.: {subItem.pagina}</div>
					<div>COR: {subItem.procor_descricao_cor.substr(0,12)}</div>
                                        <div>Tamanho: {subItem.tam_nom}</div>
                                        <div>Quantidade: {`${subItem.qtde}`} UN</div>

                                    </div>
                                </div>
                                <div className='lineBar'></div>
                            </>

}


const PedidoRelatorioCliente = ({ativaResp, showStyle}) => {

    // const navigate = useNavigate();
    

    useEffect(()=>{
        if(!showStyle) return;
        import('../../assets/css/auxiliar/scrolbar.css')
        import('../../assets/css/estiloPaginas/consultaPedidoRelatorioCliente.css')
    },[])




    const [notaInfo, setNotaInfo] = useState(null);
    const [itensNotaTratada, setItensNotaTratada] = useState(null);
    const [searchParams] = useSearchParams();
    const documento = searchParams.get("doc");


    useEffect(()=>{
        if(!documento) return;
            ConsultaPedidoRelatorioRomaneio({DOCUMENTO: documento})
                .then((resp)=>{
                    if(resp.Error){
                        
                    }else{
                        setNotaInfo(resp)
                        const respostaTratada = resp.itens.reduce((acc, curr) => {
                            if(!acc[curr.rev_nom]) {
                                acc[curr.rev_nom] = [];
                            }
                            acc[curr.rev_nom].push(curr);
                            return acc;
                        }, {});
                        setItensNotaTratada(respostaTratada)
                    }
                })
        
    },[documento])


    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current && notaInfo) {
        JsBarcode(barcodeRef.current, `088${notaInfo.cabecalho.documento.padStart(10, "0")}`, {
            displayValue: true,
            height: 80,
            margin: 0,
        });
        }
    }, [barcodeRef, notaInfo]);

    if (!notaInfo) {
        return <div>Carregando...</div>;
      }

    return <>
            {/* <div className="container mx-auto"> */}
            <div className="containerPrincipal consultaPedidoRelatorioCliente" style={{minHeight: "90vh", /*maxHeight: windowHeight*0.80,*/ display: 'flex',
    flexDirection: 'column', /*overflowY: "hidden"*/}}>

                {/* {notaInfo ? JSON.stringify(notaInfo) : ''} */}

                <div className="titleDoc">Pedido App Encomendas</div>
                <div className="infocabecalho">
                    <div className="nomeCliente">Cliente: {notaInfo.cabecalho.nomeclie}</div>
                    <div className="dataPedido">DATA: {GlobalVar.converterDataISOParaFormatoBR(notaInfo.cabecalho.data)}</div>
                    <div className="numeroPedido">Número do Pedido: {notaInfo.cabecalho.documento}</div>
                    <div className="numeroLoja">LOJA DESTINO: {notaInfo.cabecalho.loja}</div>
                </div>


                <div className="titleComp">Informações Complementares</div>
                <div className="divisor divisorResumo"></div>
                {Object.keys(itensNotaTratada).map((revistaColecaoItens,i)=>{
                    const itensArr = itensNotaTratada[revistaColecaoItens]
                    
                    return <>

                    <div className="titleRevMov fornecedor" key={`title${notaInfo.cabecalho.documento}`}>{revistaColecaoItens}</div>
                        <div className="itemsMov fornecedor" key={`itens${notaInfo.cabecalho.documento}`}>

                            {itensArr.map((subItem,i)=>{
                               return <ItemCard notaInfo={notaInfo} subItem={subItem} /> })}

                            <div className="totalItemMov">
                            <div>Subtotal</div>
                            <div>Items: {`${itensArr.reduce((acc, curr) => {
                                        return acc + parseInt(curr.qtde);
                                    }, 0)}`}</div>
                        </div>
                        
                    </div>

                    </>
                })}

                <div className="totalItemMovTotal">
                            <div>Total</div>
                            <div>Items: {`${notaInfo.cabecalho.totalitens}`}</div>
                            <div>Valor: {`${notaInfo.cabecalho.totalgeral}`}</div>
                        </div>
                        
                    
        </div>
           </>
}

export default PedidoRelatorioCliente;
